module.exports = __webpack_public_path__ + "img/video_6.4c438bbf.png";